import {Component, Inject, OnInit} from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'clu-numpad-dialog',
    templateUrl: './clu-numpad-dialog.component.html',
    styleUrls: ['./clu-numpad-dialog.component.scss'],
})
export class CluNumpadDialogComponent implements OnInit {
    numpadValue = '';
    numpadValue_S : string = '';
    numpadDigits: number[] = [1,2,3,4,5,6,7,8,9,0];
    numpadKeys: any[] = [];
    requiredLength = 0;

    constructor(
        private matDialogRef: MatDialogRef<CluNumpadDialogComponent>,
        @Inject(MAT_DIALOG_DATA) private data: { randomize?: boolean, length?: number }
    ){
        if (!!data && data.randomize === true) { this.numpadDigits = this.shuffle(this.numpadDigits); }
        if (!!data && !!data.length) { this.requiredLength = data.length; }
    }

    ngOnInit(): void {
        const numpadKeys: any[] = [];
        let index = 0;
        for (var i = 0; i < 16; i++) {
            if (i === 3) { numpadKeys.push('Backspace'); }
            else if (i === 7) { numpadKeys.push('Clear'); }
            else if (i === 11 || i === 12 || i === 14 || i === 15) { numpadKeys.push(null); }
            else if (index < this.numpadDigits.length) { numpadKeys.push(this.numpadDigits[index]); index += 1; }
            else { numpadKeys.push(null); }
        }
        this.numpadKeys = numpadKeys;

        this.matDialogRef.keydownEvents().subscribe(event => { 
            if (this.requiredLength != 0 && this.numpadValue_S.length >= this.requiredLength) { return; }

            if (['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '.'].indexOf(event.key) > - 1) { this.onNumpadClickAction_Numpad(event.key); }
            else if (event.key == 'Enter') { this.matDialogRef.close(this.numpadValue); }
            else if (event.key == 'Backspace') { this.onNumpadClickAction_Numpad(event.key); }
            else if (event.key === "Escape") { this.matDialogRef.close(); } 
        });
    }

    clearValue() {
        this.numpadValue_S = '';
        this.numpadValue = '';
    }

    onSubmit() {
        if (!this.isValid()) { return; }
        this.matDialogRef.close(this.numpadValue);
    }

    onClose() {
        this.matDialogRef.close();
    }

    onNumpadClickAction_Numpad(_key : string) { 
        if (this.requiredLength != 0 && this.numpadValue_S.length >= this.requiredLength) { return; }

        switch(_key){
            case 'Backspace' : this.numpadValue_S = this.numpadValue_S.length > 0 ? this.numpadValue_S.slice(0, -1) : '0'; break;
            default : this.numpadValue_S = this.numpadValue_S + _key; break;
        }
        this.numpadValue = this.numpadValue_S;
    }

    private shuffle(inArray: number[]): number[] {
        let array = inArray;
        let currentIndex = array.length;
        while (currentIndex != 0) {
            let randomIndex = Math.floor(Math.random() * currentIndex);
            currentIndex--;
            [array[currentIndex], array[randomIndex]] = [array[randomIndex], array[currentIndex]];
        }
        return array;
    }

    isValid(): boolean {
        return this.requiredLength == 0 || this.requiredLength == this.numpadValue.length;
    }
    
}